// src/pages/Faq.tsx
import React from "react";
import Header from "components/Header";
import Footer from "components/Footer";

export default function Faq() {
  const Wrap: React.CSSProperties = {
    maxWidth: 720,
    margin: "0 auto",
    padding: "16px 14px 40px",
    lineHeight: 1.9,
    color: "#0b1a27",
    background: "#fff",
  };
  const H1: React.CSSProperties = {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "0.02em",
    margin: "22px 0 10px",
    color: "#1e73be",
  };
  const H2: React.CSSProperties = {
    fontSize: 16,
    fontWeight: 800,
    margin: "16px 0 6px",
  };
  const P: React.CSSProperties = { margin: "8px 0" };
  const UL: React.CSSProperties = { paddingLeft: 24, margin: "4px 0 12px" };
  const Q: React.CSSProperties = { fontWeight: 800, marginTop: 10 };
  const A: React.CSSProperties = { margin: "6px 0 12px" };

  return (
    // 下付きフッター & スクロール許可
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f7fb",
        overflowY: "auto",
      }}
    >
      <Header />

      <main style={{ flex: 1 }}>
        <div style={Wrap}>
          <h1 style={H1}>よくある質問（FAQ）</h1>
          <p style={P}>
            「BOAT億MAN」に寄せられるご質問をまとめました。解決しない場合は
            <strong>お問い合わせ</strong>ページよりご連絡ください。
          </p>

          <h2 style={H2}>アカウント / ログイン</h2>
          <p style={Q}>Q. ログイン方法は？</p>
          <p style={A}>
            A.
            LINEアカウントでログイン（LIFF）に対応しています。初回は同意画面が表示されますので、案内に沿って進めてください。
          </p>
          <p style={Q}>Q. 端末変更後にログインできません。</p>
          <p style={A}>
            A.
            ブラウザ・LINEアプリのキャッシュクリア、完全終了後の再ログインをお試しください。改善しない場合はお問い合わせください。
          </p>

          <h2 style={H2}>ポイント / 決済</h2>
          <p style={Q}>Q. ポイント購入の支払い方法は？</p>
          <p style={A}>
            A.
            クレジットカード決済/外部決済（決済代行会社）/銀行振込（対応時）に対応します。購入画面の案内に従ってお手続きください。
          </p>
          <p style={Q}>Q. ポイント反映のタイミングは？</p>
          <p style={A}>
            A.
            クレジットカードは即時、銀行振込は入金確認後の反映となります（営業日基準）。反映されない場合はお問い合わせください。
          </p>
          <p style={Q}>Q. 返金はできますか？</p>
          <p style={A}>
            A.
            デジタルコンテンツの特性上、原則として返金・キャンセルはできません。重複決済等の明確な事務誤りは個別に対応します。
          </p>

          <h2 style={H2}>プラン / コンテンツ</h2>
          <p style={Q}>Q. プランの公開時刻は？</p>
          <p style={A}>
            A.
            各プラン詳細ページに記載の公開時刻以降、マイページ/購入履歴から閲覧できます。公開直後はアクセスが集中する場合があります。
          </p>
          <p style={Q}>Q. 推奨の購入金額・点数はありますか？</p>
          <p style={A}>
            A.
            プランにより「目標金額」「ステークの目安」を記載しますが、最終判断はご自身の資金管理・リスク許容度にてお願いします。
          </p>
          <p style={Q}>Q. 的中は保証されますか？</p>
          <p style={A}>
            A.
            いいえ。統計と情報に基づく予想・分析提供であり、利益・的中を保証するものではありません。
          </p>

          <h2 style={H2}>実績 / 表示</h2>
          <p style={Q}>Q. 実績の表記ルールは？</p>
          <p style={A}>
            A.
            公開した買い目/配当結果を基に、日付・レース名・払戻金額等を掲載します。表記は独自集計であり、主催者公式の記録ではありません。
          </p>
          <p style={Q}>Q. 過去の実績はどこで見られますか？</p>
          <p style={A}>
            A. 「実績」ページ、またはトップのスライダーからご確認いただけます。
          </p>

          {/* アフィリエイトのセクションは削除 */}

          <h2 style={H2}>法令 / 注意事項</h2>
          <p style={Q}>Q. 20歳未満でも利用できますか？</p>
          <p style={A}>
            A.
            いいえ。競馬法に基づき20歳未満の馬券購入は禁止されています。当サイトでも20歳未満の利用・登録はできません。
          </p>
          <p style={Q}>Q. 表現や掲載内容についての注意は？</p>
          <p style={A}>
            A.
            収益・利益・的中等の表現は将来の成果を保証するものではありません。投資判断は自己責任でお願いいたします。
          </p>

          <h2 style={H2}>サポート</h2>
          <p style={Q}>Q. 問い合わせの返答時間は？</p>
          <p style={A}>
            A.
            原則、平日10:00〜18:00に順次対応いたします（年末年始・臨時休業を除く）。混雑時はお時間をいただく場合があります。
          </p>
          <p style={Q}>Q. 連絡方法は？</p>
          <p style={A}>
            A.
            メニューの「お問い合わせ」から送信してください。必要に応じてLINEでのご連絡を行う場合があります。
          </p>

          <h2 style={H2}>技術 / 動作環境</h2>
          <p style={Q}>Q. 推奨ブラウザは？</p>
          <p style={A}>
            A.
            最新版の Chrome / Safari / Edge / Firefox を推奨します。古い端末や独自ブラウザでは正常動作しない場合があります。
          </p>
          <p style={Q}>Q. 画面が更新されない・古い表示のままです。</p>
          <p style={A}>
            A.
            ブラウザのキャッシュを削除し、ハードリロード（Windows: Ctrl+F5 / Mac: ⌘+Shift+R）をお試しください。
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
